import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
`;

const Field = styled.textarea`
  font-family: inherit !important;
  width: 100%;
  padding: 10px;
`;

class SurveyTextField extends React.Component {

  static propTypes = {
    value: PropTypes.string,
    getLabel: PropTypes.func,
    onChange: PropTypes.func,
  }

  render = () => {
    return (
      <Container>
        <Field
          value={this.props.value || ''}
          onChange={(event) => { this.props.onChange(event.target.value); }}
          placeholder={this.props.getLabel('embedded_survey.enter_your_text_generic')}
          rows="5">
      </Field>
      </Container >
    );
  }
}

export default SurveyTextField;
